import { useContext } from 'react'
import { FeaturesContext } from 'src/context/FeaturesContext'

/**
 * `useFeatures` - grabs feature gating booleans for a users default account
 *
 */
export const useFeatures = () => useContext(FeaturesContext)
